





































import {
    Component, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { UpdateinfoStore, Payload } from '@samclick-store-factory';

class FormData {
    loading: boolean = false

    isActive: boolean = false

    signupURL: string = ''

    ftdURL: string = ''
}

class UpdatePostbackTabState {
    public formData: FormData = new FormData()
}

@Component({
    components: {},
    computed: {},
    props: {},
})
export default class UpdatePostbackTab extends mixins(SamclickMixins) {
    state = new UpdatePostbackTabState();

    private readonly supportedPlaceholders = [
        'event',
        'event_date',
        'service_id',
        'brand',
        'affiliate_id',
        'affiliate_code',
        'campaign_id',
        'player_id',
        'timestamp',
        'request_id',
        'track_var1',
        'track_var2',
        'track_var3',
        'track_var4',
        'track_var5',
        'track_var6',
    ];

    rules = {}

  @Watch('ifLocaleChange', { immediate: true })
    localeChanges() {
        this.rules = {
            signupURL: [
                { validator: this.validateHttpsURL, trigger: 'blur' },
            ],
            ftdURL: [
                { validator: this.validateHttpsURL, trigger: 'blur' },
            ],
        };
    }

  getPostbackSettings() {
      UpdateinfoStore.getPostbackSettings().then((response: object) => {
          this.state.formData.isActive = !!response.data.is_active;
          this.state.formData.signupURL = response.data.signup_url || '';
          this.state.formData.ftdURL = response.data.ftd_url || '';
      });
  }

  submit() {
      this.$refs.ruleForm.validate((valid) => {
          if (valid) {
              this.showAlert(this.$t('api_error.prompt_saving').toString(), this.$data.SamclickAlert.WARNING, true).then(() => {
                  this.state.formData.loading = true;
                  UpdateinfoStore.updatePostbackSettings(new Payload({
                      is_active: this.state.formData.isActive,
                      signup_url: this.state.formData.signupURL,
                      ftd_url: this.state.formData.ftdURL,
                  })).then((response: object) => {
                      this.state.formData.loading = false;
                      this.showSuccessAlert();
                      this.state.formData.isActive = !!response.data.is_active;
                      this.state.formData.signupURL = response.data.signup_url || '';
                      this.state.formData.ftdURL = response.data.ftd_url || '';
                  }, (error) => {
                      this.state.formData.loading = false;
                      if (error && error.data && error.data.detail) {
                          this.showAlert(error.data.detail, this.$data.SamclickAlert.ERROR);
                          return;
                      }
                      this.showErrorAlert();
                  });
              }).catch(() => {});
          }
      });
  }

    validateHttpsURL(rule: object, value: string, callback: any) {
        if (!value || value.trim() === '') {
            callback();
            return;
        }

      try {
          const parsedUrl = new URL(value);
            if (parsedUrl.protocol !== 'https:') {
                callback(new Error(this.$t('update_info.err_postback_https').toString()));
                return;
            }
        } catch (e) {
            callback(new Error(this.$t('update_info.err_postback_url_invalid').toString()));
            return;
        }

        const unsupportedPlaceholder = this.getUnsupportedPlaceholder(value);
        if (unsupportedPlaceholder) {
            const errorMessage = this.$t('update_info.err_postback_placeholder_invalid')
                .toString()
                .replace('{placeholder_name}', unsupportedPlaceholder);
            callback(new Error(errorMessage));
            return;
        }

        callback();
    }

    getUnsupportedPlaceholder(value: string): string | null {
        const placeholderRegex = /\{([^{}]+)\}/g;
        let match = placeholderRegex.exec(value);

        while (match) {
            const placeholderName = match[1];
            if (this.supportedPlaceholders.indexOf(placeholderName) === -1) {
                return `{${placeholderName}}`;
            }

            match = placeholderRegex.exec(value);
        }

        return null;
    }

  created() {
      this.getPostbackSettings();
  }
}
